import React from 'react';

function AdminSettings() {
    return (
        <div>
            <h1>Settings</h1>
        </div>
    );
}

export default AdminSettings;
